const newsSlider = (selector) => () => {
    $(selector).slick({
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.6,
                    dots: true
                }
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 1.06,
                    dots: true
                }
            }
        ]
    });

    let slide = $(selector).slick("getSlick");
    if (slide.$slides.length > 3) {
        $(selector).addClass("show-slider-cursor");
    }
};

export default newsSlider;



// WEBPACK FOOTER //
// ./assets/js/modules/news-slider.js